import styled from 'styled-components'

export const StyledLabelWrapper = styled.div`
display: flex;
margin-bottom: 0.5rem;
font-weight: 700;
color: #5e6672;
`